import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ThemeNesting from './ThemeNesting';
import ClientProvider from './client';
export default createDemo(import.meta.url, ThemeNesting, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/theming/demos/theme-nesting/ThemeNesting.tsx",
    "fileName": "ThemeNesting.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { createTheme, ThemeProvider } from '@mui/material/styles';\nimport Checkbox from '@mui/material/Checkbox';\nimport { green, orange } from '@mui/material/colors';\n\nconst outerTheme = createTheme({\n  palette: {\n    primary: {\n      main: orange[500],\n    },\n  },\n});\n\nconst innerTheme = createTheme({\n  palette: {\n    primary: {\n      main: green[500],\n    },\n  },\n});\n\nexport default function ThemeNesting() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={outerTheme}>\n      <Checkbox defaultChecked />\n      <ThemeProvider theme={innerTheme}>\n        <Checkbox defaultChecked />\n      </ThemeProvider>\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 30,
        "focusedLines": 6,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { createTheme, ThemeProvider } from '@mui/material/styles';\nimport Checkbox from '@mui/material/Checkbox';\nimport { green, orange } from '@mui/material/colors';\n\nconst outerTheme = createTheme({\n  palette: {\n    primary: {\n      main: orange[500],\n    },\n  },\n});\n\nconst innerTheme = createTheme({\n  palette: {\n    primary: {\n      main: green[500],\n    },\n  },\n});\n\nexport default function ThemeNesting() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <ThemeProvider theme={outerTheme}>\n      <Checkbox defaultChecked />\n      <ThemeProvider theme={innerTheme}>\n        <Checkbox defaultChecked />\n      </ThemeProvider>\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "outerTheme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Checkbox"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "defaultChecked"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "innerTheme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Checkbox"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "defaultChecked"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 30,
    "focusedLines": 6,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Checkbox",
      "@mui/material/colors"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
